import { dbAdd, dbDelete, dbGetAll, dbGetById, dbPut } from '../indexedDb.ts';

export interface LocalInvestmentLedger {
  id: number;
  name: string;
  start_month: string;
  end_month?: string;
  currency: string;
  created_at: string;
  updated_at?: string;
  server_id?: number;
  last_synced_at?: string;
  needs_sync?: boolean;
}

export function listInvestmentLedgers() {
  return dbGetAll<LocalInvestmentLedger>('investment_ledgers');
}

export function getInvestmentLedgerById(id: number) {
  return dbGetById<LocalInvestmentLedger>('investment_ledgers', id);
}

export async function getInvestmentLedgerByServerId(serverId: number) {
  const all = await listInvestmentLedgers();
  return all.find((ledger) => ledger.server_id === serverId);
}

export async function createInvestmentLedger(
  data: Omit<LocalInvestmentLedger, 'id' | 'created_at' | 'updated_at' | 'server_id' | 'last_synced_at' | 'needs_sync'>
) {
  const now = new Date().toISOString();
  return dbAdd('investment_ledgers', { ...data, created_at: now, needs_sync: true } as any);
}

export async function updateInvestmentLedger(id: number, data: Partial<LocalInvestmentLedger>) {
  const current = await dbGetById<LocalInvestmentLedger>('investment_ledgers', id);
  if (!current) throw new Error('Ledger not found');
  const updated = {
    ...current,
    ...data,
    id,
    updated_at: data.updated_at ?? new Date().toISOString(),
    needs_sync: data.needs_sync ?? true,
  };
  await dbPut('investment_ledgers', updated);
  return updated;
}

export function removeInvestmentLedger(id: number) {
  return dbDelete('investment_ledgers', id);
}

export async function markInvestmentLedgerSynced(id: number, serverId: number) {
  const current = await dbGetById<LocalInvestmentLedger>('investment_ledgers', id);
  if (!current) throw new Error('Ledger not found');
  current.server_id = serverId;
  current.last_synced_at = new Date().toISOString();
  current.needs_sync = false;
  await dbPut('investment_ledgers', current);
  return current;
}
